import { render, staticRenderFns } from "./breakfastReal.vue?vue&type=template&id=348468ac&scoped=true"
import script from "./breakfastReal.vue?vue&type=script&lang=js"
export * from "./breakfastReal.vue?vue&type=script&lang=js"
import style0 from "./breakfastReal.vue?vue&type=style&index=0&id=348468ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348468ac",
  null
  
)

export default component.exports